/* The asterisk follows page travel; the wordmark and header never move. */
if (!customElements.get('laserlab-scroll-logo')) {
  customElements.define('laserlab-scroll-logo', class extends HTMLElement {
    connectedCallback() {
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateRotation = () => {
        this.frame = null;
        const angle = this.motionPreference.matches ? 0 : Math.max(0, window.scrollY) * 0.12;
        this.style.setProperty('--ll-logo-angle', `${angle}deg`);
      };
      this.queueRotation = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(this.updateRotation);
      };
      this.syncMotion = () => {
        window.removeEventListener('scroll', this.queueRotation);
        if (!this.motionPreference.matches) {
          window.addEventListener('scroll', this.queueRotation, { passive: true });
        }
        this.queueRotation();
      };
      this.motionPreference.addEventListener('change', this.syncMotion);
      window.addEventListener('pageshow', this.queueRotation);
      this.syncMotion();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.queueRotation);
      window.removeEventListener('pageshow', this.queueRotation);
      this.motionPreference.removeEventListener('change', this.syncMotion);
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
